/* eslint-disable */
import Cookies from 'js-cookie';
import { API } from '../../config/api';
import actions from './actions';

const { searchHeaderBegin, searchHeaderSuccess, searchHeaderErr } = actions;

const headerSearchAction = (searchData) => {
  console.log(searchData)
  return async (dispatch) => {
    try {
      dispatch(searchHeaderBegin());
      const response = await fetch(`${API.auth.user}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get('token')}`,
        },
      });

      console.log(response)

      if (!response.ok) throw new Error('Failed to fetch users');
      const { users } = await response.json();

      console.log(users)

      const filteredData = users.filter(
        (user) =>
          user.roles === 'Client' &&
          user.email?.toLowerCase().includes(searchData.toLowerCase()) &&
          user.app_id !== null,
      );

      dispatch(searchHeaderSuccess(filteredData));
    } catch (err) {
      console.error('Error fetching or searching users:', err);
      dispatch(searchHeaderErr(err.message));
    }
  };
};

export { headerSearchAction };

